module.exports = __webpack_public_path__ + "img/icon_lvsbeauty_pavilion.d1475da6.png";